var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 13,
    viewBox: "0 0 13 12",
    width: 13,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.52 1.658V3.72h.592V.982H1.64l-.82.552.234.417zM1.575 5.34a.378.378 0 01.412.363c0 .189-.104.368-.432.63l-.994.78v.498h2.057v-.552H1.455l.497-.382c.497-.348.636-.631.636-.994a.91.91 0 00-.994-.874 1.307 1.307 0 00-1.063.536l.378.363a.87.87 0 01.666-.368zM2.069 10.217a.655.655 0 00.496-.63c0-.433-.387-.75-.993-.75a1.297 1.297 0 00-1.044.496l.343.358a.884.884 0 01.646-.318c.268 0 .457.129.457.328 0 .198-.179.308-.497.308H1.19v.497h.318c.368 0 .532.104.532.313 0 .208-.174.337-.497.337a.994.994 0 01-.725-.323l-.348.388a1.417 1.417 0 001.098.462c.64 0 1.058-.343 1.058-.815a.66.66 0 00-.556-.65z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.37
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.568 2.352h7.536M4.568 6.463h7.536M4.568 10.573h7.536"
  }))));
}
export default SvgBulletNumber;